module.exports = __webpack_public_path__ + "img/Rect_Face.d0caf32c.png";